export var TimeZoneContent;
(function (TimeZoneContent) {
    TimeZoneContent["UtcM12"] = "-12:00";
    TimeZoneContent["UtcM11"] = "-11:00";
    TimeZoneContent["UtcM10"] = "-10:00";
    TimeZoneContent["UtcM09"] = "-09:00";
    TimeZoneContent["UtcM0930"] = "-09:30";
    TimeZoneContent["UtcM08"] = "-08:00";
    TimeZoneContent["UtcM07"] = "-07:00";
    TimeZoneContent["UtcM06"] = "-06:00";
    TimeZoneContent["UtcM05"] = "-05:00";
    TimeZoneContent["UtcM04"] = "-04:00";
    TimeZoneContent["UtcM0330"] = "-03:30";
    TimeZoneContent["UtcM03"] = "-03:00";
    TimeZoneContent["UtcM0230"] = "-02:30";
    TimeZoneContent["UtcM02"] = "-02:00";
    TimeZoneContent["UtcM01"] = "-01:00";
    TimeZoneContent["UtcN00"] = "+00:00";
    TimeZoneContent["UtcP14"] = "+14:00";
    TimeZoneContent["UtcP13"] = "+13:00";
    TimeZoneContent["UtcP1245"] = "+12:45";
    TimeZoneContent["UtcP12"] = "+12:00";
    TimeZoneContent["UtcP11"] = "+11:00";
    TimeZoneContent["UtcP1030"] = "+10:30";
    TimeZoneContent["UtcP10"] = "+10:00";
    TimeZoneContent["UtcP0930"] = "+09:30";
    TimeZoneContent["UtcP09"] = "+09:00";
    TimeZoneContent["UtcP0845"] = "+08:45";
    TimeZoneContent["UtcP08"] = "+08:00";
    TimeZoneContent["UtcP07"] = "+07:00";
    TimeZoneContent["UtcP0630"] = "+06:30";
    TimeZoneContent["UtcP06"] = "+06:00";
    TimeZoneContent["UtcP0545"] = "+05:45";
    TimeZoneContent["UtcP0530"] = "+05:30";
    TimeZoneContent["UtcP05"] = "+05:00";
    TimeZoneContent["UtcP0430"] = "+04:30";
    TimeZoneContent["UtcP04"] = "+04:00";
    TimeZoneContent["UtcP0330"] = "+03:30";
    TimeZoneContent["UtcP03"] = "+03:00";
    TimeZoneContent["UtcP02"] = "+02:00";
    TimeZoneContent["UtcP01"] = "+01:00";
})(TimeZoneContent || (TimeZoneContent = {}));
const textForValue = (timeZoneContent) => {
    return `UTC ${timeZoneContent}`;
};
export const timeZoneContentOptions = [
    { value: TimeZoneContent.UtcP14, text: textForValue(TimeZoneContent.UtcP14) },
    { value: TimeZoneContent.UtcP13, text: textForValue(TimeZoneContent.UtcP13) },
    { value: TimeZoneContent.UtcP1245, text: textForValue(TimeZoneContent.UtcP1245) },
    { value: TimeZoneContent.UtcP12, text: textForValue(TimeZoneContent.UtcP12) },
    { value: TimeZoneContent.UtcP11, text: textForValue(TimeZoneContent.UtcP11) },
    { value: TimeZoneContent.UtcP1030, text: textForValue(TimeZoneContent.UtcP1030) },
    { value: TimeZoneContent.UtcP10, text: textForValue(TimeZoneContent.UtcP10) },
    { value: TimeZoneContent.UtcP0930, text: textForValue(TimeZoneContent.UtcP0930) },
    { value: TimeZoneContent.UtcP09, text: textForValue(TimeZoneContent.UtcP09) },
    { value: TimeZoneContent.UtcP0845, text: textForValue(TimeZoneContent.UtcP0845) },
    { value: TimeZoneContent.UtcP08, text: textForValue(TimeZoneContent.UtcP08) },
    { value: TimeZoneContent.UtcP07, text: textForValue(TimeZoneContent.UtcP07) },
    { value: TimeZoneContent.UtcP0630, text: textForValue(TimeZoneContent.UtcP0630) },
    { value: TimeZoneContent.UtcP06, text: textForValue(TimeZoneContent.UtcP06) },
    { value: TimeZoneContent.UtcP0545, text: textForValue(TimeZoneContent.UtcP0545) },
    { value: TimeZoneContent.UtcP0530, text: textForValue(TimeZoneContent.UtcP0530) },
    { value: TimeZoneContent.UtcP05, text: textForValue(TimeZoneContent.UtcP05) },
    { value: TimeZoneContent.UtcP0430, text: textForValue(TimeZoneContent.UtcP0430) },
    { value: TimeZoneContent.UtcP04, text: textForValue(TimeZoneContent.UtcP04) },
    { value: TimeZoneContent.UtcP0330, text: textForValue(TimeZoneContent.UtcP0330) },
    { value: TimeZoneContent.UtcP03, text: textForValue(TimeZoneContent.UtcP03) },
    { value: TimeZoneContent.UtcP02, text: textForValue(TimeZoneContent.UtcP02) },
    { value: TimeZoneContent.UtcP01, text: textForValue(TimeZoneContent.UtcP01) },
    { value: TimeZoneContent.UtcN00, text: textForValue(TimeZoneContent.UtcN00) },
    { value: TimeZoneContent.UtcM01, text: textForValue(TimeZoneContent.UtcM01) },
    { value: TimeZoneContent.UtcM02, text: textForValue(TimeZoneContent.UtcM02) },
    { value: TimeZoneContent.UtcM0230, text: textForValue(TimeZoneContent.UtcM0230) },
    { value: TimeZoneContent.UtcM03, text: textForValue(TimeZoneContent.UtcM03) },
    { value: TimeZoneContent.UtcM0330, text: textForValue(TimeZoneContent.UtcM0330) },
    { value: TimeZoneContent.UtcM04, text: textForValue(TimeZoneContent.UtcM04) },
    { value: TimeZoneContent.UtcM05, text: textForValue(TimeZoneContent.UtcM05) },
    { value: TimeZoneContent.UtcM06, text: textForValue(TimeZoneContent.UtcM06) },
    { value: TimeZoneContent.UtcM07, text: textForValue(TimeZoneContent.UtcM07) },
    { value: TimeZoneContent.UtcM08, text: textForValue(TimeZoneContent.UtcM08) },
    { value: TimeZoneContent.UtcM09, text: textForValue(TimeZoneContent.UtcM09) },
    { value: TimeZoneContent.UtcM0930, text: textForValue(TimeZoneContent.UtcM0930) },
    { value: TimeZoneContent.UtcM10, text: textForValue(TimeZoneContent.UtcM10) },
    { value: TimeZoneContent.UtcM11, text: textForValue(TimeZoneContent.UtcM11) },
    { value: TimeZoneContent.UtcM12, text: textForValue(TimeZoneContent.UtcM12) },
];
//# sourceMappingURL=TimeZoneContent.js.map